/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-11-17 16:49:37
 * @LastEditTime: 2021-12-28 18:27:47
 * @FilePath: /teacher-h5/src/utils/storage.js
 */
const { localStorage } = window
const storage = {
  set (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key) {
    if (localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') return JSON.parse(localStorage.getItem(key))
    return null
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}
export default storage
